export const sxPaper = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  minHeight: '100%',
};

export const sxMain = {
  m: 2.5,
  mb: 0,
  flex: 1,
};

export const sxP20 = {
  p: 2.5,
};
